<template>
  <AppConfirmationModal
    :id="id"
    :title=$t($getConst.pages.profile.are_you_sure) | capitalize
    @onConfirm="onDelete"
  >
    <template v-slot:form >
          <p class="text-center" >to delete
          <span  v-for="(item, index) in items" >
            {{ $t($getConst.pages.timesheet.timesheet_submitted_date) }} {{item.timesheet_submitted_date}} {{ $t($getConst.pages.timesheet.timesheet_related) }} {{invoices[index].invoice_id}},
          </span>
          </p>
    </template>
  </AppConfirmationModal>
</template>

<script>
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import {} from "../../../api/vendorTimesheets.api";
    export default {
      name: "TimesheetModal",
      components:{AppConfirmationModal},
      props: {
        id: null,
        items: [],
        invoices : null,
      },
      methods : {
        onDelete(){
          this.$emit('deleleTimesheets');
        }

      },
    }

</script>

<style scoped>
  p{
    margin: 0px;
  }
</style>
